import request from './request';

async function getWithFallback(primaryPath, fallbackPath, config) {
  try {
    return await request.get(primaryPath, config);
  } catch (err) {
    if (err?.response?.status === 404) {
      return request.get(fallbackPath, config);
    }
    throw err;
  }
}

/**
 * Admin commerce refunds (docs/order-management-admin-guide.md).
 * Query: page, perPage, status, from, to (verify `from`/`to` on your API).
 */
const refundService = {
  commerceRefundsPaginate: (params) =>
    request.get('dashboard/admin/commerce/refunds/paginate', { params }),

  commerceRefundById: (id, params) =>
    request.get(`dashboard/admin/commerce/refunds/${id}`, { params }),

  commerceRefundPatchStatus: (id, data) =>
    request.patch(`dashboard/admin/commerce/refunds/${id}/status`, data, {}),

  /** Canonical admin refund list (legacy endpoints 404 on current backend). */
  getAllLegacy: (params) =>
    request.get('dashboard/admin/commerce/refunds/paginate', { params }),

  /** Main list endpoint for Refunds tabs. */
  getAll: (params) =>
    request.get('dashboard/admin/commerce/refunds/paginate', { params }),
  getList: (params) => request.get('dashboard/user/order-refunds', { params }),
  getById: (id, params) =>
    getWithFallback(
      `dashboard/admin/order-refunds/${id}`,
      `dashboard/admin/refunds/${id}`,
      { params },
    ),
  create: (data) =>
    request.post('dashboard/admin/order-refunds', data),
  createByOrder: (orderId, data) =>
    request.post(`dashboard/admin/orders/${orderId}/create-refund`, data),
  update: (id, data) =>
    request.put(`dashboard/admin/refunds/${id}`, data),
  approve: (id, data) =>
    request.post(`dashboard/admin/refunds/${id}/approve`, data ?? {}),
  delete: (data) =>
    request.delete(`dashboard/admin/order-refunds/delete`, { data }),
  deleteById: (id) =>
    request.delete(`dashboard/admin/refunds/${id}`),
  dropAll: () => request.get(`dashboard/admin/order-refunds/drop/all`),
  restoreAll: () => request.get(`dashboard/admin/order-refunds/restore/all`),
};

export default refundService;
